import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'lin-page-fatal-error',
  templateUrl: './page-fatal-error.component.html',
  styleUrls: ['./page-fatal-error.component.scss'],
  standalone: false,
})
export class PageFatalErrorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
